import { NotificationType } from '../types/notification-type';
import { addNotificationByType } from './add-notification-by-type';
export const addWarningNotification = (notificationDetails, internalActions) => {
    addNotificationByType(notificationDetails, NotificationType.Warning, internalActions);
};
